<template>
    <div>
        <v-card elevation="0" color="#FFC5D0">
            <v-card-title><v-icon>mdi-home-alert</v-icon>&nbsp;Moved to a new address?</v-card-title>
            <v-card-text>
                <v-card elevation="0" color="white">
                    <v-card-text v-if="profileloading">
                        <v-progress-linear
                            indeterminate
                            rounded
                            height="4"
                            color="#FB8DA0"
                        ></v-progress-linear>
                    </v-card-text>
                    <v-card-text v-else>
                        <div style="white-space: pre-wrap;" v-html="text"></div>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import auth from '@/js/auth';
export default {
    data(){
        return {
            host: location.hostname.toString(),
            profileloading: true,
            text: "",
        }
    },
    methods: {
        getProfileDetails(){
            const that = this;

            //Session Reading
            let user = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                user = auth.get_impersonated_user();
                that.enableEdit = false;
            }else {
                user = auth.get_user();
                that.enableEdit = true;
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getprofile&data={"uid":"'+user["uid"]+'"}';
            that.profileloading = true;
            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.text = resultData.message;
                    }else {
                        let result = resultData["data"][0];
                        if(result["address"]){
                            let address = result["address"];
                            that.text = "Your current address in our system is: \n\n \t<b>"+address["street"]+"\n\t"+address["city"]+", "+address["province"]+"\n\t"+address["postalcode"]+
                                        "</b>\n\n If the above address does not reflect your current address, please have them updated in your 'Profile' of this portal and <b>contact King's Human Resource</b>.";
                        }else {
                            that.text = "No address found in our system. Please have them entered in 'Profile' of this portal.";
                        }
                    }
                    that.profileloading = false;
                })
                .catch(function(err){
                    that.text = err;
                    that.profileloading = false;
                })
            //End of API calling
        }
    },
    created(){
        const that = this;
        that.getProfileDetails();
    }
}
</script>